<template>
  <div id="root">
    <table
      v-if="attendances && allBibleStudyParticipants"
      class="table-responsive"
      id="top-table"
    >
      <tr>
        <th class="sticky_row" />
        <th
          v-for="(attendance, index) in attendances"
          :key="attendance.id"
          @mouseover="makeHover(attendance.id)"
          @mouseleave="hoverId = null"
          @click="handleEditAttendance(index)"
          :class="{
            unknown: !attendance.submitted_at,
            attended: (attendance.submitted_at && !attendance.cancelled) || (attendance.cancelled),
            hover_column: (attendance.id === hoverId) && userCanEdit,
            sticky_row: true,
          }"
        >
          {{ attendance.met_on_date }}
          <p v-if="!attendance.submitted_at">
            Not submitted
          </p>
          <p v-if="attendance.submitted_at && !attendance.cancelled">
            Submitted
          </p>
          <p v-if="attendance.cancelled">
            Cancelled - {{ attendance.cancelled_reason }}
          </p>
        </th>
      </tr>
      <tr
        v-for="participant in allBibleStudyParticipants"
        :key="participant.person_id"
      >
        <td class="sticky-col">
          <p class="table-header">
            {{ participant.name }}
          </p>
          <p
            v-if="participant.attendance_rate != null"
          >
            {{ participant.attendance_rate }}% attended
          </p>
          <p
            v-if="participant.attendance_rate == null"
          >
            Submit reports<br>to calculate<br>attendance rate
          </p>
        </td>
        <td
          v-for="(attendance,index) in attendances"
          :key="attendance.id"
          @mouseover="makeHover(attendance.id)"
          @mouseleave="hoverId = null"
          @click="handleEditAttendance(index)"
          :class="{
            unknown: isUnknown(participant, attendance),
            attended: isAttended(participant, attendance),
            not_attended: isNotAttended(participant, attendance),
            hover_column: (attendance.id === hoverId) && userCanEdit,
          }"
        >
          <p> {{ attendanceStatus(participant, attendance) }}</p>
        </td>
      </tr>
    </table>
    <table id="bottom-table">
      <tr class="pull-right">
        <slot name="paginator" />
      </tr>
    </table>
    <EAM
      :show="modals.editAMOpen"
      :attendance="editAttendance"
      @close="modals.editAMOpen = false"
    />
  </div>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import modal from '../../UIComponents/Modal';
import EditAttendanceModal from './EditModal';

export default {
    name: 'BSATable',
    data() {
        return {
            namespace: 'BibleStudies',
            modals: {
                editAMOpen: false,
            },
            hoverId: null,
            editAttendance: null,
        };
    },
    components: {
        EAM: EditAttendanceModal,
    },
    props: {
        bibleStudy: Object,
        attendances: Array,
        userCanEdit: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            bibleStudyParticipants: (state) => state.BibleStudies.bibleStudyParticipants,
            allBibleStudyParticipants: (state) => state.BibleStudies.allBibleStudyParticipants,
        }),
    },
    methods: {
        handleEditAttendance(index) {
            if (this.userCanEdit) {
                this.editAttendance = this.getAttendanceFromIndex(index);
                this.modals.editAMOpen = !this.modals.editAMOpen;
            }
        },
        getAttendanceFromIndex(index) {
            return this.attendances[index];
        },
        // Class bindings
        isUnknown(BSP, attendance) {
            if (attendance.unknownParticipants) {
                return attendance.unknownParticipants.find(
                    (x) => x.person_id === BSP.person_id
                );
            }
            return false;
        },
        isAttended(BSP, attendance) {
            if (attendance.attendedParticipants) {
                return attendance.attendedParticipants.find(
                    (x) => x.person_id === BSP.person_id
                );
            }
            return false;
        },
        isNotAttended(BSP, attendance) {
            if (attendance.unattendedParticipants) {
                return attendance.unattendedParticipants.find(
                    (x) => x.person_id === BSP.person_id
                );
            }
            return false;
        },
        attendanceStatus(participant, attendance) {
            if (this.isUnknown(participant, attendance)) return 'Unknown';
            if (this.isAttended(participant, attendance)) return 'Attended';
            if (this.isNotAttended(participant, attendance)) return 'Not attended';
            return '';
        },
        makeHover(attendanceId) {
            this.hoverId = attendanceId;
        },
    },
    created() {
        this.$store.dispatch(`${this.namespace}/getAllBibleStudyParticipantsById`,
            { bibleStudyId: this.bibleStudy.id });
    }
};
</script>

<style scoped>
    table {
        table-layout: auto;
        width: 100%;
        max-height: 90vh;
        text-align: center;
        padding: 20px 20px 20px 0px;
        margin-top: 50px;
        box-shadow: 10px 10px 10px lightgray;
        background-color: white;
        position: relative;
        white-space: nowrap;
    }
    th, td {
        border: 1px solid white;
    }
    td, th {
        padding: 10px 35px;
    }
    p {
        margin: 0;
    }
    #top-table {
        margin-bottom: 0px;
        border-radius: 10px 10px 0 0;
    }
    #bottom-table {
        margin-top: 0px;
        border-radius: 0 0 10px 10px;
    }
    .sticky-col {
        position: sticky;
        position: -webkit-sticky;
        background-color: white;
        left: 0px;
        box-shadow: 5px 5px 5px lightgray;
    }
    .sticky_row {
        position: -webkit-sticky; /* for Safari */
        position: sticky;
        background-color: white;
        top: 0;
        box-shadow: 5px 5px 5px lightgray;
    }
    .attended {
        background-color: #6cc070;
        color: white;
    }
    .unknown {
        background-color: lightyellow;
    }
    .not_attended {
        background-color: #F56C6C;
        color: white;
    }
    .hover_column {
        cursor: pointer;
        background-color: lightgray;
    }
    .table-header {
        font-weight: bold;
    }
</style>
